/**
 * region for libraries*/
import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { withStyles } from "@material-ui/core/styles";
import {
  Grid,
  Drawer,
  Dialog,
  DialogContent,
  DialogContentText,
  Snackbar
} from "@material-ui/core";
import MuiAlert from "@material-ui/lab/Alert";
/**
 * region for styles*/
import { layoutIdentifySupplierJobsStyle } from "./style/layoutIdentifySupplierJobsStyle";

/**
 * region for redux*/
import { connect } from "react-redux";
import { IdentifySupplierJobsActions } from "../../actions/IdentifySupplierJobsActions";

/**
 * region for components*/

/**
 * region for containers*/
import FilterIdentifySupplierJobs from "../../containers/scrapy/FilterIdentifySupplierJobs";

import DetailIdentifySupplierJobs from "../../containers/scrapy/DetailIdentifySupplierJobs";

import IdentifySupplierJobs from "../../containers/scrapy/IdentifySupplierJobs";

import HeaderSupplierJobs from "../../containers/scrapy/HeaderSupplierJobs";

import Constants from "../../constants/Constants";

class LayoutIdentifySupplierJobs extends Component {
  componentDidMount() {
    this.props.getCategories();
    this.props.getKeywords();
    this.props.getKeywordsFound();
    this.props.getLocations();

    const idStatus = { idStatus: Constants.SUPPLIER_JOB_STATUS_ENUM.New };

    const beginDate = { beginDate: new Date(new Date().getTime() - 7 * 24 * 60 * 60 * 1000) };

    const endDate = { endDate: new Date() };

    let setFilters = this.props.filters;
    Object.assign(setFilters, idStatus);
    Object.assign(setFilters, beginDate);
    Object.assign(setFilters, endDate);

    const page = {
      page: 1,
    };
    Object.assign(setFilters, page);

    this.props.setFiltersAndGetList(setFilters);
  }

  handleOnCloseDrawer(event) {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    this.props.setStatusDrawer(false);
  }

  handleOnCloseSnackbar() {
    let self = this;
    self.props.setOpenSnackbar(false, Constants.ALERT_WARNING);
  }

  render() {
    const self = this;
    const {
      classes,
      statusDrawer,
      openSnackbar,
      typeAlert,
      urls,
      resultListStatusPendig,
      resultListPeding,
    } = this.props;

    let listUrlTextAlert = "";
    if (urls != null && urls.length > 0) {
      if (typeAlert === Constants.ALERT_WARNING) {
        let urlsUsedList = Array.from(urls.filter(x => x.status === "DOMAINUSED"), x => x.url);
        let domainsInvalidList = Array.from(urls.filter(x => x.status === "DOMAININVALID"), x => x.url);
        let extensionInvalidList = Array.from(urls.filter(x => x.status === "EXTENSIONINVALID"), x => x.url);
        let processedList = Array.from(urls.filter(x => x.status === "PROCESSED"), x => x.url);

        if (urlsUsedList.length > 0){
          listUrlTextAlert = "URL already linked to a Free Profile: \n" + urlsUsedList.join("\n") + "\n";
        }
        if (domainsInvalidList.length > 0){
          listUrlTextAlert += "URL has a domain that is not allowed: \n" + domainsInvalidList.join("\n") + "\n";
        }
        if (extensionInvalidList.length > 0){
          listUrlTextAlert += "URL has a extension that is not allowed: \n" + extensionInvalidList.join("\n") + "\n";
        }
        if (processedList.length > 0){
          listUrlTextAlert += "URL has been processed before: \n" + processedList.join("\n") + "\n";
        }
      } else if (typeAlert === Constants.ALERT_ERROR) {
        let urlsList = Array.from(urls, x => x.url);
        listUrlTextAlert = "Error in the following URLs, they cannot be sent to process again \n" + urlsList.join("\n");
      }
    }
    return (
      <div className={classes.root}>
        <div className={classes.content}>
          <Fragment>
            <Grid
              container
              direction="row"
              justifycontent="space-between"
              alignItems="baseline"
              spacing={0}
            >
              <Grid item xs={2}>
                <FilterIdentifySupplierJobs />
              </Grid>
              <Grid item xs={10}>
                <HeaderSupplierJobs />
                <IdentifySupplierJobs />
              </Grid>
            </Grid>
          </Fragment>
        </div>
        <Drawer
          classes={{ paper: clsx(classes.drawerDetailsPaper) }}
          anchor="right"
          open={statusDrawer}
          onClose={self.handleOnCloseDrawer.bind(this)}
        >
          <DetailIdentifySupplierJobs />
        </Drawer>
        <Snackbar
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          open={openSnackbar && urls.length > 0 ? true : false}
          autoHideDuration={openSnackbar ? 5000 : 0}
          onClose={self.handleOnCloseSnackbar.bind(this)}
        >
          <MuiAlert
            severity={typeAlert}
            elevation={6}
            variant="filled"
            className={classes.alert}
          >
            {listUrlTextAlert}
          </MuiAlert>
        </Snackbar>
        <Dialog
          open={resultListStatusPendig || resultListPeding ? true : false}
          fullScreen={false}
          disableEscapeKeyDown={true}
        >
          <DialogContent>
            <DialogContentText>Working...</DialogContentText>
          </DialogContent>
        </Dialog>
      </div>
    );
  }
}
LayoutIdentifySupplierJobs.propTypes = {
  classes: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  const pending = state.IdentifySupplierJobsReducers.pending;
  const statusDrawer = state.IdentifySupplierJobsReducers.statusDrawer;
  const urls = state.IdentifySupplierJobsReducers.urls;
  const openSnackbar = state.IdentifySupplierJobsReducers.openSnackbar;
  const typeAlert = state.IdentifySupplierJobsReducers.typeAlert;
  const filters = state.IdentifySupplierJobsReducers.filters;
  const resultListStatusPendig =
    state.IdentifySupplierJobsReducers.resultListStatusPendig;
  const resultListPeding = state.IdentifySupplierJobsReducers.resultListPeding;
  return {
    pending,
    statusDrawer,
    urls,
    openSnackbar,
    typeAlert,
    filters,
    resultListStatusPendig,
    resultListPeding,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    setStatusDrawer: (statusDrawer) =>
      dispatch(IdentifySupplierJobsActions.setStatusDrawer(statusDrawer)),
    setUrls: (urls) => dispatch(IdentifySupplierJobsActions.setUrls(urls)),
    setOpenSnackbar: (openSnackbar, typeAlert) =>
      dispatch(
        IdentifySupplierJobsActions.setOpenSnackbar(openSnackbar, typeAlert)
      ),
    setFiltersAndGetList: (filters) => {
      return dispatch(
        IdentifySupplierJobsActions.setFiltersAndGetList(filters)
      );
    },
    getCategories: (Category) => {
      return dispatch(IdentifySupplierJobsActions.getCategories(Category));
    },
    getKeywords: (keyword) => {
      return dispatch(IdentifySupplierJobsActions.getKeywords(keyword));
    },
    getKeywordsFound: (keyword) => {
      return dispatch(IdentifySupplierJobsActions.getKeywordsFound(keyword));
    },
    getLocations: () => dispatch(IdentifySupplierJobsActions.getLocations()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(layoutIdentifySupplierJobsStyle)(LayoutIdentifySupplierJobs));
